<template>
  <v-container data-test="patient">
    <v-row align="center" justify="center">
      <v-card elevation="0" width="100%" max-width="1100" class="transparent mb-5">
        <v-toolbar flat class="transparent mb-4">
          <h1 class="headline black--text mr-3">
            <router-link to="/pacientes">{{ $t('patient.patients') }}</router-link>
            / {{ paciente.fullName }}
          </h1>
          <v-spacer />
          <div v-if="!loading" sm2>
            <div v-if="paciente.sin_verificar_rrhh === 1" class="px-4 pt-4 app--page-header">
              <v-chip label outlined color="orange">{{ $t('common.sin_verificar') }} </v-chip>
            </div>
            <div v-else-if="paciente.centro !== ''" class="px-4 pt-4 app--page-header">
              <v-chip label outlined color="blue">{{ paciente.centro }}</v-chip>
            </div>
          </div>
        </v-toolbar>
        <v-card>
          <v-tabs v-model="tab" background-color="grey lighten-3">
            <v-tab
              v-for="(item, index) in tabs"
              :key="tabs_key[index]"
              data-navigation="patient-tab"
            >
              {{ loading ? '' : item }}
            </v-tab>
          </v-tabs>

          <div v-if="loading" class="text-center pa-5">
            <v-progress-circular width="2" color="primary" indeterminate />
          </div>
          <v-tabs-items v-else v-model="tab">
            <v-tab-item key="personal">
              <PersonalData />
            </v-tab-item>

            <v-tab-item v-if="permissions.clinicalHistory && !is_receptionist && !es_rrhh" key="historial">
              <History
                :patient-id="paciente.id"
                :anestesista="anestesista"
                :show-dont-have-service="showDontHaveService"
              />
            </v-tab-item>
            <v-tab-item
              v-if="!is_receptionist && !es_rrhh"
              key="receta"
            >
              <PatientPrescriptions :patient="paciente" :show-dont-have-service="showDontHaveService" />
            </v-tab-item>

            <v-tab-item v-if="permissions.documents" key="documentos">
              <Documentos
                v-if="!showDontHaveService"
                :patient="paciente"
                :is-required-data="isRequiredData"
              />
              <div v-else>
                <no-service-granted view="documentos" />
              </div>
            </v-tab-item>

            <v-tab-item v-if="showMessaging" key="4">
              <Mensajeria
                v-if="!showDontHaveService"
                :idpaciente="$route.params.id"
                :thread-id-selected="threadIdSelected"
              />
              <div v-else>
                <no-service-granted view="mensajeria" />
              </div>
            </v-tab-item>

            <v-tab-item v-if="permissions.videoConsultation !== false" key="videoconsultas">
              <Videoconsultas
                v-if="!showDontHaveService"
                :idpaciente="$route.params.id"
                :tiene-video="true"
              />
              <div v-else>
                <no-service-granted view="videoconsulta" />
              </div>
            </v-tab-item>

<!--            <v-tab-item v-if="es_rrhh" key="revisiones">-->
<!--              <Revisionmedica-->
<!--                :pacientes="pacientes"-->
<!--                :idpaciente="$route.params.id"-->
<!--                :revisiones.sync="revisiones"-->
<!--                @updateRevisions="updateRevisions"-->
<!--              />-->
<!--            </v-tab-item>-->

            <v-tab-item v-if="authUser.show_informed_consent" :key="'autorizaciones'">
              <Authorizations :patient-id="$route.params.id" :authorizations="informedConsents" />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-card>
    </v-row>
    <v-row v-if="tab === 0 && paciente.id" align="center" justify="center">
      <v-card flat elevation="0" width="100%" max-width="1100" class="transparent mb-5">
        <Triage :patient-id="paciente.id" :triage-code="paciente.triage_code" />
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import NoServiceGranted from '@/components/common/NoServiceGranted.vue';
import Documentos from '@/components/ehealth/paciente/Documentos.vue';
import History from '@/components/ehealth/paciente/History.vue';
import Mensajeria from '@/components/ehealth/paciente/Mensajeria.vue';
import Videoconsultas from '@/components/ehealth/paciente/Videoconsultas.vue';

import {
  haveEprescriptionActive,
  haveEprescription
} from '@/utils';
import Authorizations from '@/components/ehealth/paciente/Authorizations.vue';
import {
  getPacienteUrl,
  getHeader,
  getListPatientInformedConsentsUrl
} from '@/config/config';
import Triage from '@/components/triage/PatientCode';
import { navigateToEprescription } from '@/services/navigation';
import PersonalData from "@/components/ehealth/paciente/PersonalData.vue";
import PatientPrescriptions from "@/components/ehealth/paciente/PatientPrescriptions.vue";

export default {
  components: {
    PatientPrescriptions,
    PersonalData,
    History,
    Mensajeria,
    Videoconsultas,
    Documentos,
    NoServiceGranted,
    Authorizations,
    Triage,
  },

  props: {
    prescriptionToExpand: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      alerta: {
        texto: '',
        icono: '',
        color: 'info',
      },
      paciente: {
        fullName: '',
        tipoDocumento: 0,
      },

      informedConsents: [],
      authUser: JSON.parse(window.localStorage.getItem('auth_ehealth')),
      loading: true,
      tabs: ['personalData', 'History', 'Prescriptions', 'Documents', 'Messages', 'Videoconsultations'],
      tabs_key: [],
      tab: 0,
      revisiones: [],
      es_rrhh:
        window.localStorage.getItem('auth_ehealth') &&
        JSON.parse(window.localStorage.getItem('auth_ehealth'))['rol'] === 4,
      is_receptionist:
        JSON.parse(window.localStorage.getItem('auth_ehealth')) &&
        JSON.parse(window.localStorage.getItem('auth_ehealth'))['rol'] === 3,
      showMessageModule:
        window.localStorage.getItem('auth_ehealth') &&
        typeof JSON.parse(window.localStorage.getItem('auth_ehealth'))['servicios_activos'] !== 'undefined' &&
        JSON.parse(window.localStorage.getItem('auth_ehealth'))['servicios_activos']['mensajeria'] === 1,
      showElectronicPrescription: false,
      showDontHaveService: false,
      threadIdByQueryString: '',
      threadIdSelected: '',
      anestesista: false,
      isSavedDocumentIdValid: false,
    };
  },

  computed: {
    ...mapState({
      permissions: state => state.app.permissions,
      appDisplayName: state => state.app.displayName,
      companyPermissions: state => state.account.authUser.company.permissions,
    }),

    ...mapGetters({
      twoFaEnabled: 'account/twoFaEnabled',
      useNewAccountPage: 'app/getFeatureNewAccountPageFlag',
      repHomologation: 'app/getFeatureRepHomologationFlag',
    }),

    isRequiredData() {
      return !this.isSavedDocumentIdValid;
    },

    twoFaDisabled() {
      return !this.twoFaEnabled && this.useNewAccountPage && this.repHomologation;
    },
    showVideoconsultations() {
      if (this.companyPermissions) {
        return this.permissions.videoConsultation && this.companyPermissions.videoConsultation;
      }
      return this.permissions.videoConsultation;
    },
    showMessaging() {
      if (this.companyPermissions) {
        return this.permissions.messaging && this.companyPermissions?.messaging && this.showMessageModule;
      }
      return this.permissions.messaging && this.showMessageModule;
    }
  },

  mounted() {
    this.threadIdByQueryString = this.$route.params.objectId ?? '';
    this.getPatient();
    if (typeof this.$route.query.receta !== 'undefined' && this.$route.query.receta !== null) {
      this.showElectronicPrescriptionTab();
    }
  },

  created() {
    if (
      typeof this.permissions.haveElectronicPrescription !== 'undefined' &&
      haveEprescription() &&
      !this.twoFaDisabled
    ) {
      this.showElectronicPrescription = this.permissions.haveElectronicPrescription;
    }

    if (haveEprescriptionActive()) {
      this.showDontHaveService = true;
    }
  },
  methods: {
    toggleLoading(value) {
      this.loading = value;
    },

    openPrescriptionTab() {
      this.tab = 2;
    },

    openPrescription(id) {
      this.openPrescriptionTab();
      return navigateToEprescription(id);
    },

    getInformedConsents() {
      this.$http
        .get(getListPatientInformedConsentsUrl + this.$route.params.id, {
          headers: getHeader(),
        })
        .then(response => {
          this.informedConsents = response.data;
        })
        .catch(() => {
          //
        });
    },

    getPatient() {
      const param = {
        id: this.authUser.id,
        patient_id: this.$route.params.id,
        idioma: this.$i18n.locale,
        tab: 0,
        tabkey: "personal"
      };
      this.$http
        .post(getPacienteUrl, param, { headers: getHeader() })
        .then(response => {
          if (response.status === 200 && response.data && response.data.d_personales) {
            this.paciente = response.data.d_personales;
            this.anestesista = this.paciente.anestesista === 1;
            this.tipoDocumento = response.data.d_personales.tipoDocumento;
            this.isSavedDocumentIdValid = !!response.data.d_personales.dni;
            this.paciente.dni_previo = this.paciente.dni;
            this.paises = response.data.paises;
            if (this.is_receptionist) {
              this.tabs = [this.$t('patient.personal_data'), this.$t('common.videoconferences')];
              this.tabs_key = ['personal', 'videoconsultas'];
            } else if (this.authUser !== null && this.authUser.nombreEmpresa === 'Docline Hospital') {
              this.tabs = [
                this.$t('patient.personal_data'),
                this.$t('common.messaging'),
                this.$t('common.videoconferences'),
              ];
              this.tabs_key = ['personal', 'mensajes', 'videoconsultas'];
            } else {
              if (this.es_rrhh) {
                this.tabs = [
                  this.$t('patient.personal_data'),
                  this.$t('common.documents'),
                  this.$t('menu.citas'),
                  this.$tc('patient.revision_medica', 1),
                ];
                this.tabs_key = ['personal', 'documentos', 'videoconsultas', 'revisiones'];
              } else {
                this.setTabs();
                if (this.prescriptionToExpand) {
                  this.openPrescription(this.prescriptionToExpand);
                }
              }
            }
            this.paciente.triage_code = response.data.triage_code;
            this.loading = false;
          } else {
            this.alerta.texto = this.$t('errors.not_access_patient');
            this.alerta.color = 'error';
            window.localStorage.setItem('mensaje_ehealth', JSON.stringify(this.alerta));
            this.$router.push({ path: '/pacientes' });
          }
        })
        .catch(err => {
          this.$log.error(err);
          if (err.status === 403) {
            location.reload();
          }
        });
    },

    setTabs() {
      const all_tabs = [
        this.$t('patient.personal_data'),
        this.$t('patient.history_clinical'),
        this.$tc('common.prescription', 1),
        this.$t('common.documents'),
        this.$t('common.messaging'),
        this.$t('common.videoconferences'),
        this.$tc('common.authorization', 2),
      ];
      this.tabs = [];

      all_tabs.map(t => {
        switch (t) {
          case this.$t('common.messaging'):
            if (this.showMessaging) {
              this.tabs.push(t);
            }
            break;
          case this.$t('patient.history_clinical'):
            if (this.permissions.clinicalHistory) {
              this.tabs.push(t);
            }
            break;
          case this.$tc('common.prescription', 1):
            if (this.permissions.prescriptions || this.showElectronicPrescription) {
              this.tabs.push(t);
            }
            break;
          case this.$t('common.documents'):
            if (this.permissions.documents) {
              this.tabs.push(t);
            }
            break;
          case this.$tc('common.videoconferences', 1):
            if (this.showVideoconsultations) {
              this.tabs.push(t);
            }
            break;
          case this.$tc('common.authorization', 2):
            if (this.authUser.show_informed_consent) {
              this.tabs.push(t);
            }
            break;
          default:
            this.tabs.push(t);
            break;
        }
      });

      const all_tabs_key = [
        'personal',
        'historial',
        'recetas',
        'documentos',
        'mensajes',
        'videoconsultas',
        'authorizations',
      ];

      this.tabs_key = [];

      all_tabs_key.map(tab_key => {
        switch (tab_key) {
          case 'mensajes':
            if (this.showMessaging) {
              this.tabs_key.push(tab_key);
            }
            break;
          case 'historial':
            if (this.permissions.clinicalHistory) {
              this.tabs_key.push(tab_key);
            }
            break;
          case 'recetas':
            if (this.permissions.prescriptions || this.showElectronicPrescription) {
              this.tabs_key.push(tab_key);
            }
            break;
          case 'documentos':
            if (this.permissions.documents) {
              this.tabs_key.push(tab_key);
            }
            break;
          case 'videoconsultas':
            if (this.showVideoconsultations) {
              this.tabs_key.push(tab_key);
            }
            break;
          case 'authorizations':
            if (this.authUser.show_informed_consent) {
              this.tabs_key.push(tab_key);
            }
            break;
          default:
            this.tabs_key.push(tab_key);
            break;
        }
      });
      this.tab = 0;
    },

    showElectronicPrescriptionTab() {
      setTimeout(() => {
        const posEprescription = 2;
        document.querySelectorAll('.v-tab')[posEprescription].dispatchEvent(new Event('click'));
        setTimeout(() => {
          document.querySelector('#prescription-expand').click();
        }, 500);
      }, 500);
    },

    updateRevisions(data) {
      this.revisiones = data;
    },
  },
};
</script>
